import { useMediaQuery } from './useMediaQuery';

export const useIsMobile = (
  { maxWidth }: { maxWidth: number } = { maxWidth: 800 },
) => {
  return { isMobile: useMediaQuery(`(max-width:${maxWidth}px)`) };
};
